module.exports = __webpack_public_path__ + "static/img/pantos-thumb.5963c2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/pjmove-thumbs/pantos-thumb.jpg
// module id = VdwQ
// module chunks = 0